module.exports = __webpack_public_path__ + "img/location-white.e29249a5.svg";